import React, { useState, useEffect } from 'react';
import axios from '../../api';
import {
    Grid,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import InfoIcon from '@material-ui/icons/Info';
import '../../App.css';
import Swal from "sweetalert2";
import $ from "jquery";
import EncaminharPaciente from '../Actions/EncaminharPaciente';

const AtenderPacienteComponent = () => {
    const [tableData, setTableData] = useState([]);

    function sendPassword(rowId, rowName) {
        handleEncaminharPaciente(rowId, rowName)
    }

    const handleEncaminharPaciente = async (rowId, rowName) => {
        try {
            const response = await axios.put(`/triagem/encaminhar/${rowId}`);
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Muito bem',
                    text: `${rowName.toUpperCase()} foi redirecionado para o consultório`,
                    footer: 'Por favor, aguarde até que o responsável libere o consultório novamente.',
                });
                fetchConsultorios();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao encaminhar o paciente. Por favor, tente novamente.',
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Ocorreu um erro ao encaminhar o paciente. Por favor, tente novamente.',
            });
        }
    };
    const fetchConsultorios = () => {
        Swal.fire({
            title: 'Carregando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        axios
            .get('/consultorios')
            .then((response) => {
                const results = response.data.data;
                setTableData(results);

                // Verifique se o DataTable já foi inicializado na tabela
                const table = $('#consultorios').DataTable();
                if ($.fn.DataTable.isDataTable('#consultorios')) {
                    table.destroy();
                }

                // Inicialize o DataTable aqui
                $(document).ready(function () {
                    $('#consultorios').DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json',
                        },
                        deferRender: true,
                        destroy: true, // adicione essa opção
                        lengthChange: false // adicione essa opção para ocultar a seleção de quantidade de resultados
                    });
                });
            })
            .catch((error) => {
                // console.log(error);
            })
            .finally(() => {
                Swal.close();
            });
    };

    useEffect(() => {
        fetchConsultorios();
    }, [setTableData]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <br />
                <br />
                <Alert severity="info" style={{padding: '20px'}} icon={<InfoIcon />}>
                    Os funcionários da triagem devem sempre se atentar para encaminhar os pacientes aos consultórios corretos. Caso alguém seja enviado para o consultório errado, essa operação não poderá ser desfeita.
                </Alert>
                <br />
                <br />
                <TableContainer component={Card}>
                    {tableData.length > 0 ? (
                        <Table id="consultorios" aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Consultório</TableCell>
                                    <TableCell align="center">Funcionário Responsável</TableCell>
                                    <TableCell align="center">Paciente Sendo Atendido</TableCell>
                                    <TableCell align="center">Data de chegada</TableCell>
                                    <TableCell align="center">Disponibilidade do Consultório</TableCell>
                                    <TableCell align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" style={{ backgroundColor: '#f44336', color: 'white' }}>
                                            Consultório disponível para receber pacientes
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    tableData.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell component="th" scope="row">{row.consultorio}</TableCell>
                                            <TableCell align="center">{row.Funcionario_responsavel}</TableCell>
                                            <TableCell align="center">{ (row.paciente_sendo_atendido != null) ? row.paciente_sendo_atendido : 'aguardando paciente' }</TableCell>
                                            <TableCell align="center">{row.created_at}</TableCell>
                                            <TableCell align="center">
                                                <span style={{padding: '10px'}} className={`status ${row.flag === 'indisponível' ? 'status--red' : 'status--green'}`}>{row.flag}
                                                </span>
                                            </TableCell>
                                            <TableCell align="center">
                                                <EncaminharPaciente
                                                    title={"Encaminhar paciente para o Consultorio de " + row.consultorio}
                                                    sendPassword={sendPassword}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    ) : (
                        <CardContent>
                            <h4 style={{ textAlign: 'center' }}>Consultório disponível para receber pacientes</h4>
                        </CardContent>
                    )}
                </TableContainer>
            </Grid>
        </Grid>
    );
};

export default AtenderPacienteComponent;